<template>
	<div class="news-info">
		<div class="news-info__title">{{ translate("ui.news") }}</div>
		<HorizontalDecorDivider />
		<div class="news-info__item-wrapper">
			<div
				class="news-info__item"
				v-for="(item, index) in newsStore.latestNewsList"
				:key="item.id || item.title"
			>
				<div class="news-info__item-header">
					<div class="news-info__item-title">
						{{ item.title }}
					</div>
					<div class="news-info__item-date">
						{{ formatDate(new Date(item.start_date)) }}
					</div>
				</div>
				<p class="news-info__item-text" v-html="item.message" />
				<HorizontalDecorDivider
					v-if="index < newsStore.latestNewsList.length - 1"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import HorizontalDecorDivider from "@/components/SVG/HorizontalDecorDivider.vue";
import useNewsStore from "@/store/useNewsStore";
import { formatDate } from "@/utils/format";
import { translate } from "@/utils/translate";

const newsStore = useNewsStore();
</script>

<style lang="scss" scoped>
.news-info {
	width: 100%;
	@include flex-col-start;
	position: relative;
	gap: 0.5rem;
	padding: 1.25rem;
	padding-top: 0;

	&__title {
		padding-top: 0.5rem;
		width: 100%;
		color: #f4d278;
		font-weight: bold;
		font-size: 1.25rem;
		line-height: 1;
		text-align: center;
		text-transform: uppercase;
	}

	&__item {
		width: 100%;

		&-wrapper {
			@include flex-col-center;
			width: 100%;
		}

		&-header {
			display: flex;
			justify-content: space-between;
			color: #f4d278;
			& > div {
				font-weight: bold;
				font-size: 1rem;
			}
		}

		&-title {
			flex: 1 1 auto;
		}

		&-date {
			flex-shrink: 0;
		}

		&-text {
			color: #fff3dd;
		}

		.horizontal-decor-divider {
			margin: 0.625rem 0;
		}
	}

	:deep(.horizontal-decor-divider) {
		width: 100%;
	}

	:deep(ul) {
		margin-left: 1rem;
	}

	:deep(a) {
		cursor: pointer;
		color: #f2dcb5;
		text-decoration: underline;
	}
}
</style>
